<template>
  <div
    :class="`${
      !open && 'invisible'
    } fixed inset-0 z-30 bg-gray-900 bg-opacity-20 flex justify-center items-center`"
  >
    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
      mode="out-in"
    >
      <ModalContent v-if="open" :close="close">
        <slot></slot>
      </ModalContent>
    </transition>
  </div>
</template>

<script>
import ModalContent from "./ModalContent";

export default {
  name: "Modal",
  components: {
    ModalContent
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    close: {
      type: Function,
      required: true
    }
  }
};
</script>
